import { useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { useActions } from '../../../hooks/useActions';
import { useNavigateSearch } from '../../../hooks/useNavigateSearch';
import { useProcessing } from '../../../hooks/useProcessing';
import { RoutePath } from '../../../models/enums/RoutePath';
import {
  airAmbulanceOrganizationsListSelector,
  organizationsTotalCountSelector,
} from '../../../store/redux-slices/organizations/selectors';
import { ORGANIZATIONS_LOADING_PROCESSING } from '../../../store/redux-slices/processes/constants';
import { loadAAOrganizations } from '../../../store/saga-slices/organizations';

export const useCorporateCLientsAirAmbulancePage = () => {
  const dataLoading = useProcessing(ORGANIZATIONS_LOADING_PROCESSING);
  const navigation = useNavigateSearch();

  const location = useLocation();
  const LoadAAOrganizations = useActions(loadAAOrganizations);
  const airAmbulanceOrganizations = useSelector(
    airAmbulanceOrganizationsListSelector,
  );
  const organizationsTotalCount = useSelector(organizationsTotalCountSelector);

  useEffect(() => {
    const params = location.search.slice(1);
    if (params !== '') {
      LoadAAOrganizations({ params: location.search.slice(1) });
    }
  }, [LoadAAOrganizations, location.search]);

  const onRowClick = useCallback(
    ({ id }: { id: string }) =>
      navigation(RoutePath.ClientOverviewGeneralPageFullPath, {
        params: { id },
      }),
    [navigation],
  );

  return {
    onRowClick,
    dataLoading,
    organizationsTotalCount,
    airAmbulanceOrganizations,
  };
};
